import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { DIY_DOCUMENT_VERFIFICATION_STATES } from "../post-inspection-diy/constant";

const PostInspectionDiyCardHandoverDocumentCard = ({
    docList = [],
    isStandAlone,
    showDocumentList = () => {}
}) => {
    const renderStatus = (status) => {
        if (status === DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED) return "VERIFIED";
        if (status === DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING) return "PENDING";
        return "";
    };

    const getStyles = (status) => {
        if (status === DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED) return "styles.verified";
        if (status === DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING) return "styles.failed";
        return "";
    };

    return (
        <React.Fragment>
            {isStandAlone && <div>
                <h3 styleName="styles.carHandoverHeading">Things to do before pickup!</h3>
            </div>}
            {
                docList.map(({name, subText, sampleImage, rejected = false, isClickable, status, isRequired}, index) => (
                    <div key={index} styleName={`styles.documentListWrapper ${(rejected || status === DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING) ? "styles.errorState" : ""}`}>
                        <img src={sampleImage} alt={name} />
                        <div styleName={"styles.documentContent"}>
                            <h4>{name}</h4>
                            {subText && <h4>{subText}</h4>}
                            {status &&  isRequired && <p styleName={getStyles(status)}>{renderStatus(status)}</p>}
                            {
                                isClickable && isStandAlone &&
                                    <span styleName={"styles.viewAll"} onClick={showDocumentList}>
                                        View all
                                    </span>
                            }
                        </div>
                    </div>
                ))
            }
        </React.Fragment>
    );
};

PostInspectionDiyCardHandoverDocumentCard.propTypes = {
    docList: PropTypes.array,
    isStandAlone: PropTypes.bool,
    showDocumentList: PropTypes.func
};

export default PostInspectionDiyCardHandoverDocumentCard;
